import api from 'utils/apiClient';

export const getSettings = (params) => {
  return api.get('/settings', {
    params,
    headers: {
      Accept: 'application/json',
    },
  });
};

export const changeSettings = (data) => {
  return api.post(`/settings/change`, data, {
    headers: {
      Accept: 'application/json',
    },
  });
};
